import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileDropDirective } from './file-drop.directive';
import { FileUploadService } from './file-upload.service';
import { MatIconModule } from '@angular/material/icon';

import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { MatProgressBarModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    PdfJsViewerModule,
    MatProgressBarModule,
  ],
  declarations: [FileDropDirective, FileUploadComponent],
  exports: [FileDropDirective, FileUploadComponent],
  providers: [FileUploadService]
})
export class FileDropModule { }
